import { render, staticRenderFns } from "./EmptyTableMessage.vue?vue&type=template&id=55183e6a&scoped=true"
import script from "./EmptyTableMessage.vue?vue&type=script&lang=js"
export * from "./EmptyTableMessage.vue?vue&type=script&lang=js"
import style0 from "./EmptyTableMessage.vue?vue&type=style&index=0&id=55183e6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55183e6a",
  null
  
)

export default component.exports